import { Box, Container, Stack, Card, Grid, SvgIcon, TextField, Button, Typography, Paper, CircularProgress, LinearProgress } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../components/layout/Layout";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import { emailTempSave, getEmailTemp, editEmailTemp, emailFlagOff } from "../../redux/actions/EmailAction";
import { useSettings } from "src/hooks/use-settings";
import { createSearchParams, Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "src/api/endpoints";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PmwCreator({ user }) {
  const { t } = useTranslation();
  const settings = useSettings();
  const [searchParams, setSearchParams] = useSearchParams(); 
  const navigate = useNavigate()
  

  const [error, setError] = useState('')
  const [successProgress, setSuccessProgress] = useState(100)
  const timerRef = useRef(null)

  useEffect(() => {
    const getAccess = async () => {
        const code = searchParams.get('code')

        if (code) {
            try {
                const paramsData = new URLSearchParams()
                paramsData.set('redirect_uri', process.env.REACT_APP_PMW_REDIRECT_URL)
                paramsData.set('code', code)
                paramsData.set('grant_type', 'authorization_code')
                paramsData.set('client_id', process.env.REACT_APP_PMW_CLIENT_ID)
                console.log(paramsData.toString())
            
                const {data, status} = await api.post(
                  '/postermywall/token', 
                    paramsData.toString(), 
                    {
                        headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }
                )
    
                if (status == 200) {
                    // PosterMyWall returns expires_in in seconds — convert to ms
                    const expiresInMs = Number(data.expires_in) * 1000 || 0;
                    window.localStorage.setItem('PMWcred', JSON.stringify({
                      "access_token": data.access_token,
                      "token_type": data.token_type,
                      "expires_in": data.expires_in,
                      "refresh_token": data.refresh_token,
                      "user_id": data.user_id,
                      "expires_at": Date.now() + expiresInMs
                    }))
                    setError("SUCCESS")
                    startCountProgress()
                }else {
                    setError("SERVER_ERROR")
                }
            } catch (error) {
                setError("SERVER_ERROR")
            }
        }else {
            setError('NO_CODE')
        }
    }
    // if (!window.localStorage.getItem("PMWcred") && error == '') {
        getAccess()
    // }
  }, [])

  const startCountProgress = () => {
    const duration = 5000
    const step = Math.max(1, Math.floor(duration / 100))
    if (timerRef.current) {
      clearInterval(timerRef.current)
      timerRef.current = null
    }
    timerRef.current = setInterval(() => {
      setSuccessProgress((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current)
          timerRef.current = null
          navigate({pathname: "/files", search: createSearchParams({
            'pmw': '1'
          }).toString()})
          return 0
        }
        return prev - 1
      })
    }, step)
  }

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }, [])

  return (
    <>
      <Layout title={"PosterMyWall creator"} user={user}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 2,
          }}>
          <Container maxWidth={settings.stretch ? false : "xl"}>
            <Card sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                maxWidth: "500px",
                transform: "translate(-50%, -50%)",
                maxHeight: "500px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 3,
                gap: "30px",
                pb: 4
            }}>
                {error == 'NO_CODE' || error == 'SERVER_ERROR' ? (
                    <>
                        <Paper elevation={3} />
                        <img src={"./images/postermywallLogo.png"} alt="Logo" width={"100px"} />
                        <Typography variant="subtitle1" color="warning">Failed to authorize PosterMyWall</Typography>  
                        <Link to={'/files'}>
                            <Button variant="contained">Back to files</Button>
                        </Link>
                    </>
                ) : error == 'SUCCESS' ? (
                    <>
                        <Paper elevation={3} />
                        <img src={"./images/postermywallLogo.png"} alt="Logo" width={"100px"} />
                        <CheckCircleIcon color="success" sx={{
                            width: "50px"
                        }} />
                        <Typography variant="subtitle1">PosterMyWall successfully authorized</Typography>  
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"                            
                        }}>
                            <Link to={{pathname: "/files", search: createSearchParams({
                                'pmw': '1'
                            }).toString()}}>
                                <Button variant="contained" sx={{
                                    mb: 1
                                }}>Back to PosterMyWall widget creator</Button>
                            </Link>
                            <LinearProgress variant="determinate" value={successProgress} sx={{
                                width: "90%"
                            }} />                
                        </Box>    
                    </>
                ) : (
                    <>
                        <Paper elevation={3} />
                        <img src={"./images/postermywallLogo.png"} alt="Logo" width={"100px"} />
                        <CircularProgress size={"30px"} />
                        <Typography variant="subtitle1">Authorizing postermywall...</Typography>                    
                    </>
                )}
            </Card>
          </Container>
        </Box>
      </Layout>
    </>
  );
}

export default PmwCreator;
